"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextBoxRun = void 0;
const react_1 = __importDefault(require("react"));
const tags_1 = require("./tags");
const TextBoxRun = props => {
    return (react_1.default.createElement(tags_1.w.r, null,
        react_1.default.createElement(tags_1.w.drawing, null,
            react_1.default.createElement(tags_1.wp.inline, { distT: "0", distB: "0", distL: "0", distR: "0" },
                react_1.default.createElement(tags_1.wp.extent, { cx: "0", cy: "0" }),
                react_1.default.createElement(tags_1.wp.docPr, { id: props.id, name: props.name }),
                react_1.default.createElement(tags_1.a.graphic, { "xmlns:a": "http://schemas.openxmlformats.org/drawingml/2006/main" },
                    react_1.default.createElement(tags_1.a.graphicData, { uri: "http://schemas.microsoft.com/office/word/2010/wordprocessingShape" },
                        react_1.default.createElement(tags_1.wps.wsp, null,
                            react_1.default.createElement(tags_1.wps.cNvSpPr, { txBox: "1" },
                                react_1.default.createElement(tags_1.a.spLocks, { noChangeArrowheads: "1" })),
                            react_1.default.createElement(tags_1.wps.spPr, { bwMode: "auto" },
                                react_1.default.createElement(tags_1.a.xfrm, null,
                                    react_1.default.createElement(tags_1.a.off, { x: "0", y: "0" })),
                                react_1.default.createElement(tags_1.a.prstGeom, { prst: "rect" },
                                    react_1.default.createElement(tags_1.a.avLst, null)),
                                react_1.default.createElement(tags_1.a.noFill, null)),
                            react_1.default.createElement(tags_1.wps.txbx, null,
                                react_1.default.createElement(tags_1.w.txbxContent, null, props.children)),
                            react_1.default.createElement(tags_1.wps.bodyPr, { rot: "0", vert: "horz", wrap: "none", lIns: "0", tIns: "0", rIns: "0", bIns: "0", anchor: "t", anchorCtr: "0" },
                                react_1.default.createElement(tags_1.a.spAutoFit, null)))))))));
};
exports.TextBoxRun = TextBoxRun;
exports.default = exports.TextBoxRun;
//# sourceMappingURL=TextBoxRun.js.map